import React from 'react'
import { IconRegularError } from '@notino/react-styleguide'

// styled
import * as SC from './GoogleMapsErrorStyles'

// hooks
import useMessages from '../../hooks/useMessages'

const GoogleMapsError = () => {
	const { messages } = useMessages()
	return (
		<SC.ErrorContainer>
			<IconRegularError width={'2rem'} height={'2rem'} color={'text.primary'} />
			{messages['We are sorry. Google Maps could not be loaded.']}
		</SC.ErrorContainer>
	)
}

export default GoogleMapsError
